
type Props = {
  color?:string
}

function SvgComponent(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={'100%'}
      height={'100px'}
      viewBox="0 0 600.1 150"
    >
      <g fill={props.color || "#000000"}>
        <path
          data-name="Path 5"
          d="M295.1 17.9v17.9l-19.2.4-19.3.3-6.8 3.2c-36.9 17.5-31.9 70.3 7.8 80.9 14.4 3.9 31.6-1.3 41.8-12.6a51.649 51.649 0 0010.7-21.9c.6-3.1 1-22.5 1-45.7V0h-16zm0 50.3c0 14.8-.3 17.9-1.9 21.4-6.6 14.5-23.6 20.8-37.6 14a27.405 27.405 0 01-7.7-43.9c7.3-7.6 10.6-8.5 31-8.6l16.2-.1z"
        />
        <path
          data-name="Path 6"
          d="M22.4 38.1C14.8 41 7 48.5 3.5 56.2L.6 62.5.3 92.2 0 122h16l.3-28.8.3-28.9 2.8-4c4.2-6.1 9.5-8.6 17.2-8.1 5.3.3 7.1.9 10.1 3.4 7.6 6.1 7.9 7.4 8.2 38.6l.3 27.8h15.9V93.7c0-31.7.1-32.2 7.4-38.1 3.1-2.6 4.8-3.1 10.4-3.4 6-.3 7.2 0 11.3 2.6a19.156 19.156 0 016.8 7.4c2 4.2 2.1 5.9 2.1 32.1V122h16V94.1c0-25.5-.2-28.5-2.1-34.7-1.8-5.7-3.1-7.7-8.2-12.9-8.4-8.4-14.8-10.8-26.7-10.3-7.3.3-9.4.9-14.7 3.7a44.029 44.029 0 00-8.4 5.7l-2.2 2.3-4-3.4c-6.8-5.8-12.1-7.8-22.2-8.2-7.3-.2-10 .1-14.2 1.8z"
        />
        <path
          data-name="Path 7"
          d="M167.4 38.4C152.6 44 142.9 55.9 139.9 72c-1.4 7.5.1 17.8 3.7 25.8 2.8 6.2 12.2 16 18.3 19.1 17.2 8.8 36.2 5.9 51.2-7.7l5.5-5-5.4-5.6-5.5-5.5-4.8 4.5a41.315 41.315 0 01-9.6 6.6c-5.8 2.6-15.1 2.8-20.7.4l-3.9-1.7 24.7-24.7 24.8-24.8-5.5-5.3a59.546 59.546 0 00-12.3-8.4c-6-2.8-8-3.2-16.8-3.4-8.5-.3-10.9 0-16.2 2.1zm23.6 14c1.9.7 3.6 1.7 3.8 2.2.2.6-8 9.1-18.3 18.9C162.3 87.2 157.7 91 157 89.9a39.5 39.5 0 01-1.9-6.5c-2.6-12.5 5.3-26.3 17.6-30.8 4.8-1.8 13.7-1.9 18.3-.2z"
        />
        <path data-name="Path 8" d="M325.1 79v43h15V36h-15z" />
        <path
          data-name="Path 9"
          d="M384.4 37.5c-6.6 2-12.4 5.8-18.1 11.9-16.3 17.2-15.9 43 .8 59.7 8.7 8.7 18.9 12.9 31.7 12.9h6.3v-14.7l-7-.6c-17.2-1.4-28.1-12.3-27.9-27.7.2-16.3 10.4-26.8 27.1-27.8l7.8-.5V36l-8.2.1c-4.6 0-10.2.6-12.5 1.4z"
        />
        <path
          data-name="Path 10"
          d="M448.5 38a43.74 43.74 0 00-28.6 33.8c-3.7 21.5 10.4 43.2 31.7 48.7 4.5 1.1 11.6 1.5 30.2 1.5h24.3v-20.8c0-11.4-.5-24-1-28a43.346 43.346 0 00-28.7-35.3c-7.4-2.5-20.7-2.5-27.9.1zm26.1 15.8c4.7 2.4 10.5 8.2 13.1 13.2 1.6 3 2 6.3 2.2 21.9l.4 18.3-16.9-.4c-14.7-.4-17.4-.7-21.8-2.7-10.6-4.7-16.5-13.7-16.5-25.4 0-12.8 6.4-21.7 18.9-26.4 5-1.9 15.6-1.1 20.6 1.5z"
        />
        <path data-name="Path 11" d="M520.1 79v43h15V36h-15z" />
        <path
          data-name="Path 12"
          d="M578.3 37.9c-12.5 4.3-23.4 15.4-27.2 27.8-1.8 5.8-2 9.3-2 31.4V122h16V96.7c0-25.2 0-25.3 2.6-30.5 4.6-9.4 12.8-14.3 24.7-15l7.7-.5V36h-8.2c-5.4.1-10.2.7-13.6 1.9z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
